import { atom } from 'jotai';

export const MODULE_NOT_RANK = -1;

export const $CurrentModuleRank = atom<number>(MODULE_NOT_RANK);
